import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Link, makeStyles, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import * as Yup from "yup";
import { getAuthErrorMessage } from "../../constants/AuthErrorMessages";
import FormInput from "../Form/FormInput";

const useStyles = makeStyles((theme) => ({
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));
const validationSchema = Yup.object({
  password: Yup.string()
    .min(8, "Passwort muss minderstens 8 Zeichen lang sein")
    .required("Passwort eingeben"),
  confirmPassword: Yup.string()
    .required("Wiederholen dein Passwort")
    .oneOf([Yup.ref("password")], "Passwörter stimmen nicht überein"),
});

export interface NewPasswordFormValues {
  password: string;
  confirmPassword: string;
}
export type NewPasswordFormFunction = (
  values: NewPasswordFormValues
) => Promise<any>;

interface Props {
  onSubmit: NewPasswordFormFunction;
}

const initialValues: NewPasswordFormValues = {
  password: "",
  confirmPassword: "",
};

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://protect-first.de/">
        protect first
      </Link>
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}
const NewPasswordForm: React.FC<Props> = ({ onSubmit }) => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const methods = useForm<NewPasswordFormValues>({
    resolver: yupResolver(validationSchema),
    defaultValues: initialValues,
    mode: "all",
  });
  const classes = useStyles();
  const { handleSubmit, setError } = methods;

  const _onSubmit = (values: NewPasswordFormValues) => {
    setLoading(true);
    onSubmit(values).catch(({ error: { code, name, message } }) => {
      setLoading(false);
      setError("password", {
        message: getAuthErrorMessage(code, name, message),
      });
    });
  };
  return (
    <FormProvider {...methods}>
      <Box mt={5}>
        <Typography>Sie müssen ihr Passwort ändern!</Typography>
      </Box>
      <form className={classes.form} onSubmit={handleSubmit(_onSubmit)}>
        <FormInput
          variant="outlined"
          margin="normal"
          required
          fullWidth
          name="password"
          label="Passwort wiederholen"
          type="password"
          id="password"
          autoComplete="current-password"
        />
        <FormInput
          variant="outlined"
          margin="normal"
          required
          fullWidth
          name="confirmPassword"
          label="Passwort wiederholen"
          type="password"
          id="confirmPassword"
          autoComplete="current-password"
        />
        <Button
          type="submit"
          fullWidth
          disabled={loading}
          variant="contained"
          color="primary"
          className={classes.submit}
          onClick={handleSubmit(_onSubmit)}
        >
          Passwort ändern
        </Button>

        <Box mt={5}>
          <Copyright />
        </Box>
      </form>
    </FormProvider>
  );
};

export default NewPasswordForm;
